(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5810],{

/***/ 17285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 49546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _ampContext = __webpack_require__(17285);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react["default"].useContext(_ampContext.AmpStateContext));
}

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 16505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__(930);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _sideEffect = _interopRequireDefault(__webpack_require__(70148));

var _ampContext = __webpack_require__(17285);

var _headManagerContext = __webpack_require__(60523);

var _amp = __webpack_require__(49546);

var _utils = __webpack_require__(67206);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headElements List of multiple <Head> instances
 */


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react["default"].Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !props.inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _objectSpread({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 70148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray = __webpack_require__(7980);

var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _assertThisInitialized = __webpack_require__(92191);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var isServer = false;

var _class = /*#__PURE__*/function (_react$Component) {
  _inherits(_class, _react$Component);

  var _super = _createSuper(_class);

  function _class(props) {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this, props);

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances["delete"](this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _class;
}(_react.Component);

exports["default"] = _class;

/***/ }),

/***/ 74953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ BlogItem; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49642);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16645);
/* harmony import */ var _components_elements_Blog_BlogTag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9294);
/* harmony import */ var _components_elements_Blog_Interviewee__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1300);
/* harmony import */ var _hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7257);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var BlogItem = function BlogItem(_ref) {
  var _id = _ref._id,
      coverImage = _ref.coverImage,
      title = _ref.title,
      tag = _ref.tag,
      publishDate = _ref.publishDate,
      interviewee = _ref.interviewee;
  var isMobile = (0,_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__/* .useMediaQuery */ .a)('(max-width: 1047px)');
  var cover = isMobile && coverImage.spCoverImage ? coverImage.spCoverImage : coverImage.pcCoverImage;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Article, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: "/news/blog/".concat(_id),
      passHref: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(CoverImage, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
            src: cover.src,
            height: "100%",
            width: "100%",
            alt: cover.altText
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(Content, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Date, {
              dateTime: publishDate,
              children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_7__/* .formatDate */ .p6)(publishDate, 'yyyy.MM.dd')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Title, {
              children: title
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(TagWrapper, {
              children: tag.map(function (tagItem) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_elements_Blog_BlogTag__WEBPACK_IMPORTED_MODULE_3__/* .BlogTag */ .F, _objectSpread({}, tagItem), tagItem._id);
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_elements_Blog_Interviewee__WEBPACK_IMPORTED_MODULE_4__/* .Interviewee */ .d, _objectSpread({}, interviewee))]
          })]
        })]
      })
    })
  });
};
var Article = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].article.withConfig */ .ZP.article.withConfig({
  displayName: "BlogItem__Article",
  componentId: "sc-w76rui-0"
})(["width:316px;height:447px;transition:0.3s;&:hover{> a > div > img{opacity:0.6;}time,h3{color:", ";}}@media screen and (max-width:1047px){width:100%;height:451px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue);
var CoverImage = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BlogItem__CoverImage",
  componentId: "sc-w76rui-1"
})(["height:188px;> img{border-radius:8px 8px 0 0;object-fit:cover;}@media screen and (max-width:1047px){height:208px;}"]);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BlogItem__Content",
  componentId: "sc-w76rui-2"
})(["height:calc(100% - 188px);padding:19px 25px 26px;display:flex;flex-direction:column;justify-content:space-between;background-color:#ffffff;border-style:solid;border-color:", ";border-width:0 2px 2px 2px;border-radius:0 0 8px 8px;> div{overflow:hidden;}@media screen and (max-width:1047px){height:calc(100% - 208px);padding:18px 22px 24px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.backgroundPaleBlue */ .r.colors.backgroundPaleBlue);
var Date = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].time.withConfig */ .ZP.time.withConfig({
  displayName: "BlogItem__Date",
  componentId: "sc-w76rui-3"
})(["color:", ";font-size:12px;letter-spacing:1.2px;"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.textSecond */ .r.colors.textSecond);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "BlogItem__Title",
  componentId: "sc-w76rui-4"
})(["font-size:18px;line-height:24px;letter-spacing:1.8px;color:", ";font-weight:bold;height:74px;margin-top:9px;@media screen and (max-width:1047px){font-size:16px;letter-spacing:1.6px;margin-top:8px;height:72px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.textTitle */ .r.colors.textTitle);
var TagWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BlogItem__TagWrapper",
  componentId: "sc-w76rui-5"
})(["display:flex;align-items:center;gap:10px;margin-bottom:19px;"]);

/***/ }),

/***/ 9294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ BlogTag; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var BlogTag = function BlogTag(_ref) {
  var name = _ref.name,
      tagColor = _ref.tagColor;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, {
    color: tagColor,
    children: ["#", name]
  });
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "BlogTag__Tag",
  componentId: "sc-1yvutcw-0"
})(["font-size:16px;line-height:27px;letter-spacing:0;color:#ffffff;background-color:", ";padding:0 18px 0 16px;border-radius:14px;@media screen and (max-width:1047px){font-size:13px;line-height:23px;}"], function (_ref2) {
  var color = _ref2.color;
  return color;
});

/***/ }),

/***/ 1300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Interviewee; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Interviewee = function Interviewee(_ref) {
  var profileImage = _ref.profileImage,
      fullName = _ref.fullName,
      biography = _ref.biography;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Content, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
      src: profileImage.src,
      width: "44px",
      height: "44px",
      alt: fullName
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EditorName, {
        children: fullName
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EditorPosition, {
        children: biography
      })]
    })]
  });
};
var Content = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Interviewee__Content",
  componentId: "sc-13t4m1r-0"
})(["display:flex;align-items:center;gap:13px;"]);
var Image = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "Interviewee__Image",
  componentId: "sc-13t4m1r-1"
})(["border-radius:50%;"]);
var EditorName = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Interviewee__EditorName",
  componentId: "sc-13t4m1r-2"
})(["font-size:15px;line-height:17px;letter-spacing:1.5px;color:", ";margin-bottom:2px;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle);
var EditorPosition = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Interviewee__EditorPosition",
  componentId: "sc-13t4m1r-3"
})(["font-size:11px;line-height:15px;letter-spacing:1.1px;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textSecond */ .r.colors.textSecond);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 7257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useMediaQuery = function useMediaQuery(mediaQuery) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isMatch = _useState[0],
      setIsMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var mediaQueryList = window.matchMedia(mediaQuery);

    var documentChangeHandler = function documentChangeHandler() {
      setIsMatch(mediaQueryList.matches);
    };

    mediaQueryList.addEventListener('change', documentChangeHandler);
    documentChangeHandler();
    return function () {
      mediaQueryList.removeEventListener('change', documentChangeHandler);
    };
  }, [mediaQuery]);
  return isMatch;
};

/***/ }),

/***/ 77715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MachidukuriPage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/pages/News/Machidukuri/Detailed/MachidukuriSummary.tsx
var MachidukuriSummary = [{
  title: "1. まちづくりのコンセプト",
  images: ["/images/news-machidukuri-1-1.jpg"]
}, {
  title: "2. スマートサービス",
  images: ["/images/news-machidukuri-2-1.jpg", "/images/news-machidukuri-2-2.jpg"]
}, {
  title: "3. 都市空間",
  images: ["/images/news-machidukuri-3-1.jpg"]
}, {
  title: "4. 都市機能",
  images: ["/images/news-machidukuri-4-1.jpg", "/images/news-machidukuri-4-2.jpg"]
}, {
  title: "5. まちづくりのマネジメント",
  images: ["/images/news-machidukuri-5-1.jpg"]
}];
;// CONCATENATED MODULE: ./src/components/pages/News/Machidukuri/Detailed/MachidukuriThoughts.tsx
var MachidukuriThoughts = [{
  _id: '65c9872ff46bbd64cb2cd400',
  _sys: {
    raw: {
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      firstPublishedAt: '2024-02-12T06:55:58.840Z',
      publishedAt: '2024-02-12T06:55:58.840Z'
    },
    createdAt: '2024-02-12T06:55:58.840Z',
    updatedAt: '2024-02-12T06:55:58.840Z',
    customOrder: 1
  },
  coverImage: {
    pcCoverImage: {
      _id: '6368b1040fc2fdb8ea8216aa',
      altText: '',
      description: '',
      fileName: 'profileImg.png',
      fileSize: 413079,
      fileType: 'image/png',
      height: 450,
      width: 634,
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/6f1d61f9-7e68-48a9-8ce2-1ca67258513a/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_1_1040x360.png',
      title: ''
    },
    spCoverImage: {
      _id: '6369b1040fc2fdb8ea8216aa',
      altText: '',
      description: '',
      fileName: 'profileImg.png',
      fileSize: 413079,
      fileType: 'image/png',
      height: 450,
      width: 634,
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/6f1d61f9-7e68-48a9-8ce2-1ca67258513a/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_1_1040x360.png',
      title: ''
    }
  },
  title: '①IT小売企業のトライアルグループと、日本有数（現段階45社、目標100社以上）の企業群が、DXの力で福岡をシリコンバレーのようなイノベーション地域に変える。すべての生活（食と健康）をよくして日本を元気にする！',
  tag: [{
    _id: '3bb39c1e-5423-4ca8-b7e0-9d688cb90928',
    tagColor: '#d38e69',
    name: '経営',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z'
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1
    }
  }],
  body: '',
  interviewee: {
    _id: '87c4f45e-f7a3-42ff-8d5e-f55251d325c7',
    fullName: '亀田晃一',
    profileImage: {
      _id: '0d13630a-42c4-4e79-9187-b60192067184',
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/9b71f3a4-5bfc-4199-9a16-5bf1213d610f/%E4%BA%80%E7%94%B0%E6%99%83%E4%B8%80.png',
      fileType: 'image/png',
      fileName: '',
      fileSize: 1028,
      width: 44,
      height: 44
    },
    biography: '代表取締役社長',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z'
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1
    }
  },
  publishDate: '2024-02-12'
}, {
  _id: '65c987f2f46bbd64cb2e0f23',
  _sys: {
    raw: {
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      firstPublishedAt: '2024-02-12T06:55:58.840Z',
      publishedAt: '2024-02-12T06:55:58.840Z'
    },
    createdAt: '2024-02-12T06:55:58.840Z',
    updatedAt: '2024-02-12T06:55:58.840Z',
    customOrder: 1
  },
  coverImage: {
    pcCoverImage: {
      _id: '6368b1040fc2fdb8ea8216aa',
      altText: '',
      description: '',
      fileName: 'profileImg.png',
      fileSize: 413079,
      fileType: 'image/png',
      height: 450,
      width: 634,
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/af5dba61-0e67-4a4e-8418-62d61952358c/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_2_1040x360.png',
      title: ''
    },
    spCoverImage: {
      _id: '6369b1040fc2fdb8ea8216aa',
      altText: '',
      description: '',
      fileName: 'profileImg.png',
      fileSize: 413079,
      fileType: 'image/png',
      height: 450,
      width: 634,
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/af5dba61-0e67-4a4e-8418-62d61952358c/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_2_1040x360.png',
      title: ''
    }
  },
  title: '②IT小売企業のトライアルグループと、日本有数（現段階45社、目標100社以上）の企業群が、DXの力で福岡をシリコンバレーのようなイノベーション地域に変える。すべての生活（食と健康）をよくして日本を元気にする！',
  tag: [{
    _id: '3bb39c1e-5423-4ca8-b7e0-9d688cb90928',
    tagColor: '#d38e69',
    name: '経営',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z'
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1
    }
  }],
  body: '',
  interviewee: {
    _id: '87c4f45e-f7a3-42ff-8d5e-f55251d325c7',
    fullName: '亀田晃一',
    profileImage: {
      _id: '0d13630a-42c4-4e79-9187-b60192067184',
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/9b71f3a4-5bfc-4199-9a16-5bf1213d610f/%E4%BA%80%E7%94%B0%E6%99%83%E4%B8%80.png',
      fileType: 'image/png',
      fileName: '',
      fileSize: 1028,
      width: 44,
      height: 44
    },
    biography: '代表取締役社長',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z'
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1
    }
  },
  publishDate: '2024-02-12'
}, {
  _id: '65c98890f46bbd64cb2e6c39',
  _sys: {
    raw: {
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      firstPublishedAt: '2024-02-12T06:55:58.840Z',
      publishedAt: '2024-02-12T06:55:58.840Z'
    },
    createdAt: '2024-02-12T06:55:58.840Z',
    updatedAt: '2024-02-12T06:55:58.840Z',
    customOrder: 1
  },
  coverImage: {
    pcCoverImage: {
      _id: '6368b1040fc2fdb8ea8216aa',
      altText: '',
      description: '',
      fileName: 'profileImg.png',
      fileSize: 413079,
      fileType: 'image/png',
      height: 450,
      width: 634,
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/5fb7c198-e2f8-445f-af22-e03abf051ff4/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_3_1040x360.png',
      title: ''
    },
    spCoverImage: {
      _id: '6369b1040fc2fdb8ea8216aa',
      altText: '',
      description: '',
      fileName: 'profileImg.png',
      fileSize: 413079,
      fileType: 'image/png',
      height: 450,
      width: 634,
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/5fb7c198-e2f8-445f-af22-e03abf051ff4/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_3_1040x360.png',
      title: ''
    }
  },
  title: '③IT小売企業のトライアルグループと、日本有数（現段階45社、目標100社以上）の企業群が、DXの力で福岡をシリコンバレーのようなイノベーション地域に変える。すべての生活（食と健康）をよくして日本を元気にする！',
  tag: [{
    _id: '3bb39c1e-5423-4ca8-b7e0-9d688cb90928',
    tagColor: '#d38e69',
    name: '経営',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z'
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1
    }
  }],
  body: '',
  interviewee: {
    _id: '87c4f45e-f7a3-42ff-8d5e-f55251d325c7',
    fullName: '亀田晃一',
    profileImage: {
      _id: '0d13630a-42c4-4e79-9187-b60192067184',
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/9b71f3a4-5bfc-4199-9a16-5bf1213d610f/%E4%BA%80%E7%94%B0%E6%99%83%E4%B8%80.png',
      fileType: 'image/png',
      fileName: '',
      fileSize: 1028,
      width: 44,
      height: 44
    },
    biography: '代表取締役社長',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z'
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1
    }
  },
  publishDate: '2024-02-12'
}, {
  _id: '65c988e7f46bbd64cb2e8933',
  _sys: {
    raw: {
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      firstPublishedAt: '2024-02-12T06:55:58.840Z',
      publishedAt: '2024-02-12T06:55:58.840Z'
    },
    createdAt: '2024-02-12T06:55:58.840Z',
    updatedAt: '2024-02-12T06:55:58.840Z',
    customOrder: 1
  },
  coverImage: {
    pcCoverImage: {
      _id: '6368b1040fc2fdb8ea8216aa',
      altText: '',
      description: '',
      fileName: 'profileImg.png',
      fileSize: 413079,
      fileType: 'image/png',
      height: 450,
      width: 634,
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/e3b4d883-f5c6-4e67-b17f-59b933696e3f/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_4_1040x360.png',
      title: ''
    },
    spCoverImage: {
      _id: '6369b1040fc2fdb8ea8216aa',
      altText: '',
      description: '',
      fileName: 'profileImg.png',
      fileSize: 413079,
      fileType: 'image/png',
      height: 450,
      width: 634,
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/e3b4d883-f5c6-4e67-b17f-59b933696e3f/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_4_1040x360.png',
      title: ''
    }
  },
  title: '④IT小売企業のトライアルグループと、日本有数（現段階45社、目標100社以上）の企業群が、DXの力で福岡をシリコンバレーのようなイノベーション地域に変える。すべての生活（食と健康）をよくして日本を元気にする！',
  tag: [{
    _id: '3bb39c1e-5423-4ca8-b7e0-9d688cb90928',
    tagColor: '#d38e69',
    name: '経営',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z'
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1
    }
  }],
  body: '',
  interviewee: {
    _id: '87c4f45e-f7a3-42ff-8d5e-f55251d325c7',
    fullName: '亀田晃一',
    profileImage: {
      _id: '0d13630a-42c4-4e79-9187-b60192067184',
      src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/9b71f3a4-5bfc-4199-9a16-5bf1213d610f/%E4%BA%80%E7%94%B0%E6%99%83%E4%B8%80.png',
      fileType: 'image/png',
      fileName: '',
      fileSize: 1028,
      width: 44,
      height: 44
    },
    biography: '代表取締役社長',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z'
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1
    }
  },
  publishDate: '2024-02-12'
}];
// EXTERNAL MODULE: ./src/components/elements/Blog/BlogItem/index.tsx
var BlogItem = __webpack_require__(74953);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/pages/News/Machidukuri/Detailed/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var Detailed = function Detailed() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopMessageContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TopMessageText, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BlockTitle, {
          children: "\u8857\u3065\u304F\u308A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306F\u3001\u5B50\u4F1A\u793E\u306E\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30EA\u30A2\u30EB\u30A8\u30B9\u30C6\u30FC\u30C8\u3092\u4EE3\u8868\u4F01\u696D\u3068\u3057\u3066\u3001\u56FD\u7ACB\u5927\u5B66\u6CD5\u4EBA\u4E5D\u5DDE\u5927\u5B66\u304A\u3088\u3073\u72EC\u7ACB\u884C\u653F\u6CD5\u4EBA\u90FD\u5E02\u518D\u751F\u6A5F\u69CB\uFF08UR\u90FD\u5E02\u6A5F\u69CB\uFF09\u304C\u516C\u52DF\u4E3B\u4F53\u3068\u306A\u308A\u3001\u4E21\u8005\u304C\u798F\u5CA1\u770C\u798F\u5CA1\u5E02\u306B\u6240\u6709\u3059\u308B28\u30D8\u30AF\u30BF\u30FC\u30EB\u306E\u571F\u5730\u306E\u958B\u767A\u6848\u4EF6\u3078\u306E\u5FDC\u52DF\u3092\u884C\u3063\u3066\u3044\u307E\u3057\u305F\u304C\u3001\u6B8B\u5FF5\u306A\u304C\u3089\u512A\u5148\u4EA4\u6E09\u6A29\u3092\u7372\u5F97\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: ["\u3057\u304B\u3057\u3001\u5F53\u793E\u304C\u63D0\u6848\u3092\u3057\u305F", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "\u300CALL JAPAN\u3067DX\u3092\u63A8\u9032\u3059\u308B\u300D"
          }), "\u3001", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "\u300C\u535A\u591A\u30D9\u30A4\u30A8\u30EA\u30A2\u3092\u65E5\u672C\u306E\u30B7\u30EA\u30B3\u30F3\u30D0\u30EC\u30FC\u306B\u3059\u308B\u300D"
          }), "\u3068\u3044\u3046\u30D3\u30B8\u30E7\u30F3\u304C\u5909\u308F\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u306F\u672C\u6848\u4EF6\u3067\u3054\u63D0\u6848\u3055\u305B\u3066\u3044\u305F\u3060\u3044\u305F\u5185\u5BB9\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306B\u3001\u4ECA\u5F8C\u3082\u3042\u3089\u3086\u308B\u53EF\u80FD\u6027\u3092\u63A2\u308A\u307E\u3059\u3002"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlockTitle, {
      children: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6982\u8981"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SummaryContainer, {
      children: MachidukuriSummary.map(function (summary, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SummaryTitle, {
            children: summary.title
          }), summary.images.map(function (image, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
              src: image
            }, idx);
          }), index === 2 && /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkContainer, {
            children: ["\u5BAE\u82E5\u5E02\u3067\u306E\u53D6\u308A\u7D44\u307F\u306B\u3064\u3044\u3066\u306F\u3053\u3061\u3089\uFF1A", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://trial-holdings.inc/business",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                children: "https://trial-holdings.inc/business/"
              })
            })]
          })]
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlockTitle, {
      children: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u601D\u3044"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
      children: MachidukuriThoughts.map(function (item) {
        return /*#__PURE__*/(0,react.createElement)(BlogItem/* BlogItem */.l, _objectSpread(_objectSpread({
          isPickUp: false,
          pickUpSummary: null,
          utilMeta: null,
          individualMeta: null
        }, item), {}, {
          key: item._id
        }));
      })
    })]
  });
};
var List = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Detailed__List",
  componentId: "sc-19i9p1w-0"
})(["display:flex;align-items:center;flex-wrap:wrap;gap:47px 46px;@media screen and (max-width:1047px){flex-direction:column;justify-content:normal;row-gap:24px;padding:0 20px;}"]);
var TopMessageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Detailed__TopMessageContainer",
  componentId: "sc-19i9p1w-1"
})(["width:1040px;margin:0 auto;@media screen and (max-width:1047px){width:100%;}"]);
var TopMessageText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Detailed__TopMessageText",
  componentId: "sc-19i9p1w-2"
})(["width:100%;font-size:18px;color:", ";text-align:left;letter-spacing:0.36px;line-height:32px;strong{font-weight:bold;}h3{font-size:28px;letter-spacing:1.68px;font-weight:bold;color:", ";margin-bottom:44px;}p{margin-bottom:2em;}@media screen and (max-width:1047px){font-size:15px;letter-spacing:0.6px;line-height:25px;margin-top:58px;margin-bottom:0px;h3{max-width:225px;font-size:20px;letter-spacing:2px;line-height:30px;margin-bottom:30px;}}"], theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var BlockTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "Detailed__BlockTitle",
  componentId: "sc-19i9p1w-3"
})(["margin-top:80px;margin-bottom:40px;font-size:28px;font-weight:bold;letter-spacing:1.68px;line-height:42px;color:", ";@media screen and (max-width:1047px){margin-top:30px;font-size:20px;letter-spacing:1.2px;line-height:28px;}&:first-child{margin-top:0;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var SummaryContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Detailed__SummaryContainer",
  componentId: "sc-19i9p1w-4"
})(["display:flex;flex-direction:column;gap:50px;"]);
var SummaryTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
  displayName: "Detailed__SummaryTitle",
  componentId: "sc-19i9p1w-5"
})(["margin-bottom:10px;font-size:18px;letter-spacing:1.68px;line-height:42px;@media screen and (max-width:1047px){font-size:16px;letter-spacing:1.2px;line-height:28px;}"]);
var LinkContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Detailed__LinkContainer",
  componentId: "sc-19i9p1w-6"
})(["font-weight:bold;margin-top:20px;line-height:1.8;& > a:hover{text-decoration:underline;}"]);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Detailed__Image",
  componentId: "sc-19i9p1w-7"
})(["width:100%;margin-bottom:10px;"]);
;// CONCATENATED MODULE: ./src/components/pages/News/Machidukuri/index.tsx






var MachidukuriPage = function MachidukuriPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MachidukuriMain, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Detailed, {})
  });
};

MachidukuriPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: 'ニュースルーム',
    path: '/news/'
  }, {
    name: '街づくりプロジェクト',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Main, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u8857\u3065\u304F\u308A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306F\u3001\u300CALL JAPAN\u3067DX\u3092\u63A8\u9032\u3059\u308B\u300D\u3001\u300C\u535A\u591A\u30D9\u30A4\u30A8\u30EA\u30A2\u3092\u65E5\u672C\u306E\u30B7\u30EA\u30B3\u30F3\u30D0\u30EC\u30FC\u306B\u3059\u308B\u300D\u3068\u3044\u3046\u30D3\u30B8\u30E7\u30F3\u306E\u3082\u3068\u3001\u4ECA\u5F8C\u3082\u3042\u3089\u3086\u308B\u53EF\u80FD\u6027\u3092\u63A2\u3063\u3066\u3044\u304D\u307E\u3059\u3002",
      ogp: {
        url: 'news/machidukuri/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* ImageTitleLayout */.Cr, {
      title: "\u30C8\u30E9\u30A4\u30A2\u30EB\u3000\u8857\u3065\u304F\u308A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
      subTitle: "\u30C8\u30E9\u30A4\u30A2\u30EB\u3000\u8857\u3065\u304F\u308A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
      imgUrl: "/images/news-machidukuri.jpg",
      breadCrumbs: breadCrumbs,
      isRequiredBackground: false,
      children: page
    })]
  });
};

var MachidukuriMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Machidukuri__MachidukuriMain",
  componentId: "sc-1wsl7a2-0"
})(["width:1040px;margin:0 auto;padding:98px 0 130px;@media screen and (max-width:1047px){width:100%;padding:0 20px 70px;}"]);
var Main = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Machidukuri__Main",
  componentId: "sc-1wsl7a2-1"
})(["h2{display:none;}@media screen and (max-width:1047px){h2{display:flex;}}"]);
;// CONCATENATED MODULE: ./src/pages/news/machidukuri/index.tsx


/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 75080:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/machidukuri",
      function () {
        return __webpack_require__(77715);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,2167,5548,9774,2888,179], function() { return __webpack_exec__(75080); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);